import { api } from "./api";

export const fetchIntegrations = () =>
  api.get("/integrations").then((r) => r.data);

export const syncIntegration = (key) =>
  api.post(`/integrations/${key}/sync`).then((r) => r.data);
